import styled from 'styled-components';

import { Row, SimpleButton } from '@components/formStyles';

export const ContainerRoomDetail = styled.div`
  height: auto;
  position: relative;
  margin-top: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 3px 0 2px 0;
    margin-top: 0;
  }
`;

export const Wrapper = styled.div`
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  padding: 54px 26px 16px 26px;
  margin-top: 3px;
  margin-bottom: 20px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 10px 0 2px 0;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    border: none;
    padding: 15px 16px;
  }
`;

export const StyledRow = styled(Row)`
  min-width: 95px;
  margin-top: 20px;
  text-align: center;
  justify-content: center;
`;

export const CardContainer = styled.div``;

export const TabWrapper = styled.div<{ direction: string }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 77px;
  overflow-y: auto;
  position: sticky;
  top: ${({ direction }) => (direction === 'down' ? '49px' : '147px')};
  transition: all 0.19s;

  background-color: ${({ theme }) => theme.palette.white};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    top: 185px;
    height: auto;
  }
`;

export const StyledSimpleButton = styled(SimpleButton)<{ isSelected: boolean }>`
  font-size: 20px;
  font-weight: bold;

  &:first-child {
    margin-left: 40px;
  }

  :not(:first-child) {
    margin-left: 20px;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    &:first-child {
      margin-left: 25px;
    }
  }

  ${({ isSelected, theme }) =>
    isSelected
      ? `border-bottom: 4px solid ${theme.palette.tomato}; 
         color: ${theme.palette.coral};
         `
      : `color: ${theme.palette.darkGrey};`}

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    font-size: 16px;
  }
`;

export const RoomsCardHeader = styled.div`
  display: flex;
  justify-content: end;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 11px;
`;

export const LimitSeturPointsWrapper = styled.div`
  width: calc(100% - 16px);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 8px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 10px;
    width: 100%;
  }
`;
